import { useEffect } from "react";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { ObjectHelper } from "../../utils/ObjectHelper";
import { enmMonths } from "../../models/enums/Months";

export type MonthSelectProps = {
    onChange?: Function;
    value?: any;
    labelType?: "name" | "number" | undefined;
    mode?: "multiple" | "tags" | undefined;
    specificTypes?: enmMonths[];
}

export const MonthSelect = (props: MonthSelectProps) => {
    const { t } = useTranslation();

    useEffect(() => {
    }, [props]);

    let items: { name: string; id: number }[] = props.specificTypes ? ObjectHelper.getEnumKeyValuesForSpecificTypes(enmMonths, props.specificTypes) : ObjectHelper.enumToObjectArray(enmMonths);

    return (
        <>
            <Select
                mode={props.mode}
                size="middle"
                value={props.mode == "multiple" ? props.value as string[] : props.value as string}
                onChange={(value: string | string[]) => props.onChange ? props.onChange(value) : undefined}
                showSearch
                placeholder={t("common.choose")}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={items?.map(h => Object.assign(h, {
                    label: props.labelType && props.labelType == "number" ? h.id.toString() : h.name,
                    value: h.id
                }))}
            />
        </>
    )
}